import React from "react";
import { useTranslation } from "react-i18next";

function Timing() {
   const { t } = useTranslation();
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/slider-1.jpg)',backgroundSize:'cover',backgroundPosition:'top'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px',padding:'50px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row">
          <div class="col-md-12" style={{backgroundImage:'url(./images/slider-1.jpg)',backgroundSize:'cover',backgroundPosition:'center',height:'100px'}}>
                
            </div>
            <div className="col-md-12" style={{background:'#ffffffd2',padding:'50px',border:'1px solid silver'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                       <center><p className="enquiry">{t("dtime")}</p> </center>                                         
                    </div>
                </div>
                <div className="row" style={{marginBottom:'50px',paddingTop:'15px'}}>
                    {/* <center>
                          <h3 className="theading" style={{fontSize:'20px',fontWeight:'700',marginTop:'-20px',textAlign:'center'}}>Alpashi Festival from 16-10-2025 to 31-10-2025</h3>
                      </center> */}
                    {/* first */}


                   
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">{t("dtm")}</h3>
                            <ul>
                                <li className="timelist">{t("mt-1")}</li>
                               <li className="timelist">{t("mt-2")}</li>
                                <li className="timelist">{t("mt-3")}</li>
                                <li className="timelist">{t("mt-4")}</li>
                                 <li className="timelist">{t("mt-5")}</li>
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">{t("dte")}</h3>
                                <ul>
                                    <li className="timelist">{t("et-1")}</li>
                                   <li className="timelist">{t("et-2")}</li>
                                    <li className="timelist">{t("et-3")}</li>
                                   <li className="timelist">{t("et-4")}</li>
                                </ul>
                      </div>
                    </div>
                    <p className="timelist">
                        <li className="timelist">{t("des")}</li>
                    </p>
                </div>
           </div> 
            
        </div>
        
        
      </div>
    </div>
  );
}

export default Timing;